import React from "react";
import { Offcanvas, OffcanvasHeader, OffcanvasBody } from "reactstrap";
import "../../assets/scss/common/commonOffcanvasLayout.scss";
import TruncatedText from "./TruncatedText";

interface CommonOffcanvasLayoutProps {
  isOpen: boolean;
  toggle: () => void;
  title: string;
  width?: string | number;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

const CommonOffcanvasLayout: React.FC<CommonOffcanvasLayoutProps> = ({
  isOpen,
  toggle,
  title,
  width = "400px",
  children,
  footer,
}) => {
  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle}
      direction="end"
      backdrop="static"
      fade
      style={{
        width,
        maxWidth: "95vw",
      }}
      className="d-flex flex-column"
    >
      {/* Header */}
      <OffcanvasHeader
        toggle={toggle}
        className="border-bottom border-2 p-3"
      >
       <TruncatedText text={title} maxWidth="300px" />
        
      </OffcanvasHeader>

      {/* Scrollable Body */}
      <OffcanvasBody
        className="flex-grow-1 overflow-auto pt-3"
      >
        {children}
      </OffcanvasBody>

      {/* Sticky Footer */}
      {footer && (
        <div
          className="border-top bg-white"
          style={{
            position: "sticky",
            bottom: 0,
            zIndex: 10,
            padding: "10px 16px",
          }}
        >
          {footer}
        </div>
      )}
    </Offcanvas>
  );
};

export default CommonOffcanvasLayout;
